// Mapping between page keys, DA paths, EN paths, and SEO metadata
export const SITE_DOMAIN = "https://mettebrudvig.dk";

export const PAGES = [
  {
    key: "home",
    da: {
      path: "/",
      title: "Mette Brudvig | Ny Tids Lederskab, Hjertets Intelligens & Bevidsthed",
      description: "Træd ind i Hjertets tidsalder med Mette Brudvig. Foredrag, retreats, clairvoyance sessioner og mentorforløb i Ny Tids Lederskab og Hjertets Intelligens."
    },
    en: {
      path: "/en",
      title: "Mette Brudvig | New Era Leadership, Heart Intelligence & Consciousness",
      description: "Step into the Age of the Heart with Mette Brudvig. Keynotes, retreats, clairvoyance sessions, think tank and mentoring in New Era Leadership."
    }
  },
  {
    key: "foredrag",
    da: {
      path: "/foredrag",
      title: "Foredrag & Workshops | Mette Brudvig",
      description: "Inspirerende og forandringsskabende foredrag og workshops om Ny Tids Lederskab, hjertets intelligens og personlig power for virksomheder og private."
    },
    en: {
      path: "/en/keynotes",
      title: "Keynotes & Workshops | Mette Brudvig",
      description: "Inspiring and transformative keynotes and workshops on New Era Leadership, heart intelligence and personal power for organizations and individuals."
    }
  },
  {
    key: "foredrag-privat",
    da: {
      path: "/foredrag/privat",
      title: "Foredrag til Private | Mette Brudvig",
      description: "Foredrag for dig, der ønsker at frisætte dit fulde potentiale, styrke din intuition og træde ind i din autentiske styrke."
    },
    en: {
      path: "/en/keynotes/private",
      title: "Keynotes for Individuals | Mette Brudvig",
      description: "Keynotes for individuals seeking to unleash their full potential, strengthen intuition, and step into authentic power."
    }
  },
  {
    key: "foredrag-virksomheder",
    da: {
      path: "/foredrag/virksomheder",
      title: "Foredrag til Virksomheder | Mette Brudvig",
      description: "Gør din virksomhed og dit lederskab klar til den nye tid. Foredrag om bæredygtigt lederskab, trivsel og hjertets intelligens i erhvervslivet."
    },
    en: {
      path: "/en/keynotes/businesses",
      title: "Keynotes for Businesses | Mette Brudvig",
      description: "Prepare your organization and leadership for the new era. Keynotes on sustainable leadership, workplace well-being, and heart intelligence."
    }
  },
  {
    key: "virksomheder-spring-ind-i-fremtiden",
    da: {
      path: "/virksomheder/spring-ind-i-fremtiden",
      title: "Spring ind i fremtiden | Virksomhedsworkshop | Mette Brudvig",
      description: "Bliv klar til fremtiden og høst alle de gunstige fordele – for både individet og organisationen. Workshop med Mette Brudvig."
    },
    en: {
      path: "/en/keynotes/businesses/leap-into-the-future",
      title: "Leap Into the Future | Business Workshop | Mette Brudvig",
      description: "Get ready for the future and reap all the beneficial advantages – for both the individual and the organization. Workshop with Mette Brudvig."
    }
  },
  {
    key: "virksomheder-ny-energi-i-teamet",
    da: {
      path: "/virksomheder/ny-energi-i-teamet",
      title: "Ny energi i teamet | Virksomhedsworkshop | Mette Brudvig",
      description: "Skab trivsel og performance ved at skabe en højere energi. Workshop for teams og organisationer med Mette Brudvig."
    },
    en: {
      path: "/en/keynotes/businesses/new-energy-in-the-team",
      title: "New Energy in the Team | Business Workshop | Mette Brudvig",
      description: "Create well-being and performance by generating higher energy. Workshop for teams and organizations with Mette Brudvig."
    }
  },
  {
    key: "virksomheder-fremstaa-trovaerdig",
    da: {
      path: "/virksomheder/fremstaa-trovaerdig",
      title: "Fremstå troværdig | Virksomhedsworkshop | Mette Brudvig",
      description: "Lær at kommunikere rent, så mennesker ikke bare bakker op, men naturligt følger dig. Workshop med Mette Brudvig."
    },
    en: {
      path: "/en/keynotes/businesses/communicate-with-authenticity",
      title: "Communicate with Authenticity & Trust | Business Workshop | Mette Brudvig",
      description: "Learn to communicate cleanly so people don't just agree, but naturally follow you. Workshop with Mette Brudvig."
    }
  },
  {
    key: "virksomheder-aktiver-hjertets-intelligens",
    da: {
      path: "/virksomheder/aktiver-hjertets-intelligens",
      title: "Aktivér hjertets intelligens i organisationen | Virksomhedsworkshop | Mette Brudvig",
      description: "Styrk medarbejdernes evne til at mærke sig selv, træffe klarere beslutninger og bidrage med større autenticitet og nærvær."
    },
    en: {
      path: "/en/keynotes/businesses/activate-heart-intelligence",
      title: "Activate Heart Intelligence in the Organization | Business Workshop | Mette Brudvig",
      description: "Strengthen the ability to feel oneself, make clearer decisions, and contribute with authenticity, responsibility, and human presence."
    }
  },
  {
    key: "frisaet-dig",
    da: {
      path: "/frisaet-dig",
      title: "Frisæt Dig | Mette Brudvig",
      description: "Frisæt dig selv fra præstation, overudviklet kontrol og frygt. Oplev et dybtgående forløb med Mette Brudvig."
    },
    en: {
      path: "/en/unleash-yourself",
      title: "Unleash Yourself | Mette Brudvig",
      description: "Unleash yourself from performance pressure, control, and fear. Experience a deep transformative program with Mette Brudvig."
    }
  },
  {
    key: "frisaet-dig-fysisk",
    da: {
      path: "/frisaet-dig/fysisk-forloeb",
      title: "Fysisk Årsuddannelse | Frisæt Dig | Mette Brudvig",
      description: "Vi mødes én gang om måneden i København eller Århus. Her får du undervisning, fælles healing, øvelser og sparring i et trygt og nærværende fællesskab."
    },
    en: {
      path: "/en/unleash-yourself/physical-program",
      title: "1-Year Physical Education | Unleash Yourself | Mette Brudvig",
      description: "We meet once a month in Copenhagen or Aarhus. Here you get teaching, joint healing, exercises and sparring in a safe and supportive community."
    }
  },
  {
    key: "frisaet-dig-online",
    da: {
      path: "/frisaet-dig/online-forloeb",
      title: "Online Årsforløb | Frisæt Dig | Mette Brudvig",
      description: "Du får den samme undervisning og udviklingsrejse live online med gruppesparring, øvelser, optagelser og onlinefællesskab mellem modulerne."
    },
    en: {
      path: "/en/unleash-yourself/online-program",
      title: "1-Year Online Program | Unleash Yourself | Mette Brudvig",
      description: "You get the same teaching and development journey live online with group sparring, exercises, recordings and an online community between modules."
    }
  },
  {
    key: "frisaet-dig-video",
    da: {
      path: "/frisaet-dig/videoforloeb",
      title: "12-Ugers Videoforløb | Frisæt Dig | Mette Brudvig",
      description: "En kompakt og effektiv kickstart til at styrke hjertets intelligens og sætte din personlige transformation i gang."
    },
    en: {
      path: "/en/unleash-yourself/video-program",
      title: "12-Week Video Program | Unleash Yourself | Mette Brudvig",
      description: "A compact and effective kickstart to strengthen your heart intelligence and start your personal transformation."
    }
  },
  {
    key: "frisaet-dig-workshop",
    da: {
      path: "/frisaet-dig/workshop",
      title: "Workshop | Frisæt Dig | Mette Brudvig",
      description: "På denne workshop arbejder vi med at fjerne de lag, der forhindrer dig i at mærke og leve fra din sjælskerne."
    },
    en: {
      path: "/en/unleash-yourself/workshop",
      title: "Workshop | Unleash Yourself | Mette Brudvig",
      description: "In this workshop, we dissolve the layers blocking you from living from your soul core."
    }
  },
  {
    key: "frisaet-dig-workshop-praktisk",
    da: {
      path: "/frisaet-dig/workshop/praktisk-information",
      title: "Praktisk Information | Frisæt Dig Kurser | Mette Brudvig",
      description: "Praktisk information om Frisæt dig 1-dags kurser i Sønderborg (14. nov.), Aarhus (5. dec.) og København (12. dec.). Datoer, adresser, forplejning og tilmelding."
    },
    en: {
      path: "/en/unleash-yourself/workshop/practical-information",
      title: "Practical Information | Unleash Yourself 1-Day Courses | Mette Brudvig",
      description: "Practical information for the Unleash Yourself 1-day courses in Sønderborg (Nov 14), Aarhus (Dec 5) and Copenhagen (Dec 12). Schedule, venues, catering, and registration."
    }
  },
  {
    key: "frisaet-dig-foredrag",
    da: {
      path: "/frisaet-dig/foredrag",
      title: "Foredrag | Frisæt Dig | Mette Brudvig",
      description: "Foredraget Har du sjælen med? Om den styrke, der opstår, når du lever fra din sande essens."
    },
    en: {
      path: "/en/unleash-yourself/keynote",
      title: "Keynote | Unleash Yourself | Mette Brudvig",
      description: "Keynote: Do you carry your soul? The power born from living your true essence."
    }
  },
  {
    key: "kvinde-kend-din-power",
    da: {
      path: "/kvinde-kend-din-power",
      title: "KVINDE - Kend din power! | Mette Brudvig",
      description: "Et opgør med det traditionelle syn på en powerkvinde. Lær at lede med hjertet, din intuition og modne feminine energi."
    },
    en: {
      path: "/en/woman-know-your-power",
      title: "WOMAN - Know Your Power! | Mette Brudvig",
      description: "A shift from traditional views on female power. Learn to lead with your heart, intuition, and mature feminine energy."
    }
  },
  {
    key: "sessioner",
    da: {
      path: "/sessioner",
      title: "Clairvoyance & Ledersparring Sessioner | Mette Brudvig",
      description: "Mærk klarhed, dybe indsigter og personlig vejledning i clairvoyance- og ledersparringssessioner med Mette Brudvig."
    },
    en: {
      path: "/en/sessions",
      title: "Clairvoyance & Leadership Mentoring Sessions | Mette Brudvig",
      description: "Gain clarity, deep insights, and personal guidance in clairvoyance and executive mentoring sessions with Mette Brudvig."
    }
  },
  {
    key: "sessioner-clairvoyant",
    da: {
      path: "/sessioner/clairvoyant-raadgivning",
      title: "Clairvoyant Rådgivning & Personlig Sparring | Mette Brudvig",
      description: "Har du brug for klarhed og indsigt? Få clairvoyant rådgivning og personlig sparring med Mette Brudvig."
    },
    en: {
      path: "/en/sessions/clairvoyant-mentoring",
      title: "Clairvoyant Advisory & Personal Mentoring | Mette Brudvig",
      description: "Do you need clarity and insight? Experience clairvoyant advisory and personal mentoring with Mette Brudvig."
    }
  },
  {
    key: "sessioner-ledersparring",
    da: {
      path: "/sessioner/ledersparring",
      title: "Ledersparring i Ny Tids Lederskab | Mette Brudvig",
      description: "Strategisk klarhed, skærpet intuition og menneskelig indsigt til at styrke dit lederskab, din trivsel og dine beslutninger."
    },
    en: {
      path: "/en/sessions/leadership-mentoring",
      title: "Leadership Mentoring in New Era Leadership | Mette Brudvig",
      description: "Strategic clarity, heightened intuition, and human insight to strengthen your leadership, well-being, and decision-making."
    }
  },
  {
    key: "sessioner-mentor",
    da: {
      path: "/sessioner/mentorforloeb",
      title: "Mentor- og Udviklingsforløb 1:1 | Mette Brudvig",
      description: "Dyb transformation & meditation for dig, der vil integrere hjertets intelligens i din hverdag med et 1:1 mentorforløb."
    },
    en: {
      path: "/en/sessions/mentor-program",
      title: "1:1 Mentoring & Development Program | Mette Brudvig",
      description: "Deep transformation & meditation to integrate heart intelligence into your daily life with a 1:1 mentoring program."
    }
  },
  {
    key: "retreats",
    da: {
      path: "/retreats",
      title: "Retreats - Hjertets Intelligens | Mette Brudvig",
      description: "Transformative og nærende retreats i naturskønne omgivelser. Giv plads til sjælen og oplev dyb ro og fornyet energi."
    },
    en: {
      path: "/en/retreats",
      title: "Retreats - Heart Intelligence | Mette Brudvig",
      description: "Transformative and nourishing retreats in serene surroundings. Reconnect with your soul and experience deep peace."
    }
  },
  {
    key: "montserrat",
    da: {
      path: "/montserrat",
      title: "Helligt Retreat til Montserrat | Mette Brudvig",
      description: "En eksklusiv og åndelig pilgrimsrejse til det hellige bjerglandskab og kloster i Montserrat, Spanien."
    },
    en: {
      path: "/en/montserrat",
      title: "Sacred Retreat to Montserrat | Mette Brudvig",
      description: "An exclusive spiritual journey to the sacred mountain landscape and monastery of Montserrat, Spain."
    }
  },
  {
    key: "costa-del-sol",
    da: {
      path: "/costa-del-sol",
      title: "Hjem til krop og sjæl – Spirituelt retreat på Costa del Sol | Mette Brudvig",
      description: "5 dages spirituelt retreat på Costa del Sol med Mette og Louise fra 6.–11. oktober. Fordybelse, blid yoga, TRE og sjælelig ro."
    },
    en: {
      path: "/en/costa-del-sol",
      title: "Home to Body & Soul – Spiritual Retreat on Costa del Sol | Mette Brudvig",
      description: "5 days spiritual retreat on Costa del Sol with Mette and Louise from October 6th–11th."
    }
  },
  {
    key: "costa-del-sol-smagsproeve",
    da: {
      path: "/costa-del-sol/smagsproeve",
      title: "3 timer med lydhealing, blid yoga og meditation i København | Mette Brudvig",
      description: "Kom ud af hovedet og ned i kroppen den 2. september i København. 3 skønne timer med blid yoga, lydhealing og guidet healende meditation med Mette og Louise."
    },
    en: {
      path: "/en/costa-del-sol/workshop",
      title: "3 Hours with Sound Healing, Gentle Yoga & Meditation in Copenhagen | Mette Brudvig",
      description: "Get out of your head and into your body on September 2nd in Copenhagen. 3 wonderful hours with gentle yoga, sound healing and guided meditation with Mette and Louise."
    }
  },
  {
    key: "thailand-retreat",
    da: {
      path: "/thailand-retreat",
      title: "Hjem til krop og sjæl – Spirituelt retreat i Thailand | Mette Brudvig",
      description: "Træd ud af hverdagen og ind i Thailands varme, frodige og sanselige verden. 10 dages spirituelt retreat i Thailand med Mette og Louise."
    },
    en: {
      path: "/en/thailand-retreat",
      title: "Home to Body and Soul – Spiritual Retreat in Thailand | Mette Brudvig",
      description: "Step out of daily life into Thailand's warm, lush and sensual world. 10 days spiritual retreat in Thailand with Mette and Louise."
    }
  },
  {
    key: "taenketank",
    da: {
      path: "/taenketank",
      title: "NELA Tænketank & Uddannelser | Mette Brudvig",
      description: "New Earth Leaders Academy. Gentænk lederskab og fremtidens organisatoriske rammer med Mette Brudvig."
    },
    en: {
      path: "/en/think-tank",
      title: "NELA Think Tank & Education | Mette Brudvig",
      description: "New Earth Leaders Academy. Rethinking leadership and future organizational paradigms with Mette Brudvig."
    }
  },
  {
    key: "om-mette",
    da: {
      path: "/om-mette",
      title: "Om Mette Brudvig | Rejse, Baggrund & Filosofi",
      description: "Mød Mette Brudvig – tidligere kommerciel direktør og journalist, nu facilitator, clairvoyant rådgiver og New Earth Leader."
    },
    en: {
      path: "/en/about-mette",
      title: "About Mette Brudvig | Journey, Background & Philosophy",
      description: "Meet Mette Brudvig – former commercial director and journalist, now facilitator, clairvoyant advisor and New Earth Leader."
    }
  },
  {
    key: "udtalelser",
    da: {
      path: "/om-mette/udtalelser",
      title: "Udtalelser | Klienters oplevelser med Mette Brudvig",
      description: "Her kan du se et udpluk af udtalelser fra klienter, der har været i sessioner eller er i forløb med mig."
    },
    en: {
      path: "/en/about-mette/testimonials",
      title: "Testimonials | Client experiences with Mette Brudvig",
      description: "Here you can see a selection of testimonials from clients who have been in sessions or programs with me."
    }
  },
  {
    key: "virksomhedspraktik",
    da: {
      path: "/om-mette/virksomhedspraktik",
      title: "Virksomhedspraktik | SoMe Content Creator & Brand Builder | Mette Brudvig",
      description: "SoMe Content Creator & Brand Builder søges til virksomhedspraktik hos Mette Brudvig. Vær med til at bygge et stærkt brand."
    },
    en: {
      path: "/en/about-mette/internship",
      title: "Internship | SoMe Content Creator & Brand Builder | Mette Brudvig",
      description: "SoMe Content Creator & Brand Builder sought for internship with Mette Brudvig. Join in building an authentic brand."
    }
  },
  {
    key: "blog",
    da: {
      path: "/blog",
      title: "Blog | Artikler & Indsigter af Mette Brudvig",
      description: "Læs Mette Brudvigs personlige blogindlæg og artikler om den nye tid, hjertets intelligens og personlig transformation."
    },
    en: {
      path: "/en/blog",
      title: "Blog | Articles & Insights by Mette Brudvig",
      description: "Read Mette Brudvig's articles and insights on the new era, heart intelligence, and personal transformation."
    }
  },
  {
    key: "podcasts",
    da: {
      path: "/podcasts",
      title: "Podcast | Samtaler om Ny Tids Lederskab | Mette Brudvig",
      description: "Lyt til podcasts med Mette Brudvig om bevidsthed, personlig udvikling, kvantefysik og Ny Tids Lederskab."
    },
    en: {
      path: "/en/podcasts",
      title: "Podcast | Conversations on New Era Leadership | Mette Brudvig",
      description: "Listen to podcasts with Mette Brudvig on consciousness, personal development, and New Era Leadership."
    }
  },
  {
    key: "gratis",
    da: {
      path: "/gratis",
      title: "Gratis | Mette Brudvig",
      description: "Gratis online workshops, meditationer og ressourcer om Ny Tids Lederskab og personlig frisættelse med Mette Brudvig."
    },
    en: {
      path: "/en/free",
      title: "Free | Mette Brudvig",
      description: "Free online workshops, meditations, and resources on New Era Leadership and personal freedom with Mette Brudvig."
    }
  },
  {
    key: "gratis-miniworkshop",
    da: {
      path: "/frisaet-dig-miniworkshop",
      title: "Frisæt dig – Online minikursus | Mette Brudvig",
      description: "Frisæt dig: 2 timers online minikursus med Mette Brudvig."
    },
    en: {
      path: "/en/free/unleash-yourself-miniworkshop",
      title: "Online Mini-Course – Unleash Yourself | Mette Brudvig",
      description: "Online mini-course with Mette Brudvig."
    }
  },
  {
    key: "blog-detail",
    da: {
      path: "/blog/:id",
      title: "Blog | Mette Brudvig",
      description: "Læs artikler og indsigter om Ny Tids Lederskab, bevidsthed og hjertets intelligens."
    },
    en: {
      path: "/en/blog/:id",
      title: "Blog | Mette Brudvig",
      description: "Read articles and insights on New Era Leadership, consciousness and heart intelligence."
    }
  },
  {
    key: "kontakt",
    da: {
      path: "/kontakt",
      title: "Kontakt | Mette Brudvig",
      description: "Kom i kontakt med Mette Brudvig angående foredrag, retreats eller sessioner. Send en besked direkte."
    },
    en: {
      path: "/en/contact",
      title: "Contact | Mette Brudvig",
      description: "Get in touch with Mette Brudvig regarding keynotes, retreats, sessions, or the think tank. Send a direct message."
    }
  },
  {
    key: "privatlivspolitik",
    da: {
      path: "/privatlivspolitik",
      title: "Privatlivspolitik | Mette Brudvig",
      description: "Information om behandling af personoplysninger og databeskyttelse hos Mette Brudvig."
    },
    en: {
      path: "/en/privacy-policy",
      title: "Privacy Policy | Mette Brudvig",
      description: "Information regarding personal data processing and privacy protection at Mette Brudvig."
    }
  }
];

// Helper functions for routes & language resolution
export function getLanguageFromPathname(pathname) {
  if (pathname === '/en' || pathname.startsWith('/en/')) {
    return 'en';
  }
  return 'da';
}

export function getPageConfigFromPathname(pathname) {
  // Check exact matches or dynamic routes
  for (const page of PAGES) {
    if (page.da.path === pathname || page.en.path === pathname) {
      return page;
    }
    // Handle dynamic blog route e.g. /blog/abc or /en/blog/abc
    if (page.key === 'blog-detail') {
      const daBlogPrefix = '/blog/';
      const enBlogPrefix = '/en/blog/';
      if (pathname.startsWith(daBlogPrefix) || pathname.startsWith(enBlogPrefix)) {
        return page;
      }
    }
  }
  return PAGES.find(p => p.key === 'home');
}

export function getAlternatePath(pathname, targetLang) {
  const currentLang = getLanguageFromPathname(pathname);
  
  // Dynamic blog handle
  if (pathname.startsWith('/blog/') || pathname.startsWith('/en/blog/')) {
    const blogId = pathname.replace(/^\/en\/blog\//, '').replace(/^\/blog\//, '');
    return targetLang === 'en' ? `/en/blog/${blogId}` : `/blog/${blogId}`;
  }

  const page = getPageConfigFromPathname(pathname);
  if (page) {
    return page[targetLang].path;
  }

  // Fallback
  return targetLang === 'en' ? '/en' : '/';
}

export function getLocalizedPath(path, lang) {
  if (!path) return lang === 'en' ? '/en' : '/';

  // External or anchor links
  if (path.startsWith('http://') || path.startsWith('https://') || path.startsWith('mailto:') || path.startsWith('tel:') || path.startsWith('#')) {
    return path;
  }

  // Dynamic blog path
  if (path.startsWith('/blog/') || path.startsWith('/en/blog/')) {
    const id = path.replace(/^\/en\/blog\//, '').replace(/^\/blog\//, '');
    return lang === 'en' ? `/en/blog/${id}` : `/blog/${id}`;
  }

  const page = PAGES.find(p => p.da.path === path || p.en.path === path);
  if (page) {
    return page[lang].path;
  }

  if (lang === 'en' && !path.startsWith('/en')) {
    return `/en${path === '/' ? '' : path}`;
  }
  if (lang === 'da' && path.startsWith('/en')) {
    return path.replace(/^\/en/, '') || '/';
  }

  return path;
}

export function getNavLinks(lang, navCmsItems = []) {
  const cmsMap = {};
  if (Array.isArray(navCmsItems)) {
    navCmsItems.forEach((item) => {
      if (item && item.nokle) {
        const val = item.titel?.[lang] || (typeof item.titel === 'string' ? item.titel : (item.titel?.da || item.titel?.en));
        if (val && typeof val === 'string' && val.trim().length > 0) {
          cmsMap[item.nokle] = val.trim();
        }
      }
    });
  }

  const t = (key, fallback) => cmsMap[key] || fallback;

  if (lang === 'en') {
    return [
      { 
        name: t("forloeb", "Education"), 
        children: [
          { 
            name: t("frisaet_dig_forloeb", "Unleash Yourself"), 
            href: "/en/unleash-yourself",
            subChildren: [
              { name: t("frisaet_dig_fysisk", "Practical info: Physical 1-year program"), href: "/en/unleash-yourself/physical-program" }
              // { name: t("frisaet_dig_online", "Practical info: Online Personal Freedom Course"), href: "/en/unleash-yourself/online-program" }
            ]
          },
          { name: t("kvinde_kend_din_power_forloeb", "WOMAN – Know Your Power"), href: "/en/woman-know-your-power" }
        ]
      },
      {
        name: t("workshops", "Courses"),
        href: "/en/unleash-yourself/workshop",
        children: [
          { 
            name: t("frisaet_dig_workshop", "Unleash Yourself 1-Day Courses"), 
            href: "/en/unleash-yourself/workshop",
            subChildren: [
              { name: t("workshop_praktisk_info", "Practical information"), href: "/en/unleash-yourself/workshop/practical-information" }
            ]
          },
          { name: t("kvinde_kend_din_power_workshop", "WOMAN – Know Your Power Course"), href: "/en/woman-know-your-power" }
        ]
      },
      {
        name: t("foredrag", "Keynotes"),
        href: "/en/keynotes"
      },
      {
        name: t("retreats", "Retreats"),
        href: "/en/retreats",
        children: [
          { name: t("retreat_montserrat", "Montserrat"), href: "/en/montserrat" },
          { name: t("retreat_costa_del_sol", "Costa del Sol"), href: "/en/costa-del-sol" },
          { name: t("retreat_thailand", "Thailand"), href: "/en/thailand-retreat" }
        ]
      },
      { 
        name: t("sessioner", "Sessions"), 
        href: "/en/sessions",
        children: [
          { name: t("session_clairvoyant", "Clairvoyant Advisory & Personal Mentoring"), href: "/en/sessions/clairvoyant-mentoring" },
          { name: t("session_ledersparring", "Leadership Mentoring in New Era Leadership"), href: "/en/sessions/leadership-mentoring" },
          { name: t("session_mentor", "1:1 Mentoring & Development Program"), href: "/en/sessions/mentor-program" }
        ]
      },
      { 
        name: t("minikursus", "Mini-course"), 
        href: "/en/free/unleash-yourself-miniworkshop"
      },
      { 
        name: t("gratis", "Free"), 
        href: "/en/free"
      },
      { name: t("blog", "Blog"), href: "/en/blog" },
      { 
        name: t("podcast", "Podcast"), 
        href: "/en/podcasts",
        children: [
          { name: t("podcast_forbundet", "Forbundet i den nye tid"), href: "/en/podcasts#forbundet-i-den-nye-tid" },
          { name: t("podcast_fyraften", "Fyraften og sjælefred"), href: "/en/podcasts#fyraften-og-sjaelefred" }
        ]
      },
      {
        name: t("om_mette", "About Mette"),
        href: "/en/about-mette",
        children: [
          { name: t("om_mette_underside", "About Mette"), href: "/en/about-mette" },
          { name: t("udtalelser", "Testimonials"), href: "/en/about-mette/testimonials" },
          { name: t("virksomhedspraktik", "Internship"), href: "/en/about-mette/internship" }
        ]
      }
    ];
  }

  return [
    { 
      name: t("forloeb", "Uddannelse"), 
      children: [
        { 
          name: t("frisaet_dig_forloeb", "Frisæt dig uddannelse"), 
          href: "/frisaet-dig",
          subChildren: [
            { name: t("frisaet_dig_fysisk", "Praktisk om fysisk årsuddannelse"), href: "/frisaet-dig/fysisk-forloeb" }
            // { name: t("frisaet_dig_online", "Praktisk om online uddannelse (engelsk)"), href: "/frisaet-dig/online-forloeb" }
          ]
        },
        { name: t("kvinde_kend_din_power_forloeb", "Kvinde – kend din power uddannelse"), href: "/kvinde-kend-din-power" }
      ]
    },
    {
      name: t("workshops", "Kursus"),
      href: "/frisaet-dig/workshop",
      children: [
        { 
          name: t("frisaet_dig_workshop", "Frisæt dig endagskurser"), 
          href: "/frisaet-dig/workshop",
          subChildren: [
            { name: t("workshop_praktisk_info", "Praktisk information"), href: "/frisaet-dig/workshop/praktisk-information" }
          ]
        },
        { name: t("kvinde_kend_din_power_workshop", "Kvinde – kend din power kursus"), href: "/kvinde-kend-din-power" }
      ]
    },
    {
      name: t("foredrag", "Foredrag"),
      href: "/foredrag"
    },
    {
      name: t("retreats", "Retreats"),
      href: "/retreats",
      children: [
        { name: t("retreat_montserrat", "Montserrat"), href: "/montserrat" },
        { name: t("retreat_costa_del_sol", "Costa del Sol"), href: "/costa-del-sol" },
        { name: t("retreat_thailand", "Thailand"), href: "/thailand-retreat" }
      ]
    },
    { 
      name: t("sessioner", "Sessioner"), 
      href: "/sessioner",
      children: [
        { name: t("session_clairvoyant", "Clairvoyant rådgivning & personlig sparring"), href: "/sessioner/clairvoyant-raadgivning" },
        { name: t("session_ledersparring", "Ledersparring i Ny Tids Lederskab"), href: "/sessioner/ledersparring" },
        { name: t("session_mentor", "Mentor- og udviklingsforløb 1:1"), href: "/sessioner/mentorforloeb" }
      ]
    },
    { 
      name: t("minikursus", "Minikursus"), 
      href: "/frisaet-dig-miniworkshop"
    },
    { 
      name: t("gratis", "Gratis"), 
      href: "/gratis"
    },
    { name: t("blog", "Blog"), href: "/blog" },
    { 
      name: t("podcast", "Podcast"), 
      href: "/podcasts",
      children: [
        { name: t("podcast_forbundet", "Forbundet i den nye tid"), href: "/podcasts#forbundet-i-den-nye-tid" },
        { name: t("podcast_fyraften", "Fyraften og sjælefred"), href: "/podcasts#fyraften-og-sjaelefred" }
      ]
    },
    {
      name: t("om_mette", "Om Mette"),
      href: "/om-mette",
      children: [
        { name: t("om_mette_underside", "Om Mette"), href: "/om-mette" },
        { name: t("udtalelser", "Udtalelser"), href: "/om-mette/udtalelser" },
        { name: t("virksomhedspraktik", "Virksomhedspraktik"), href: "/om-mette/virksomhedspraktik" }
      ]
    }
  ];
}
